import * as React from 'react';
import Selector from '../generic/Selector';
import { INPUT_TYPES, type itemIssues } from './constants';

type Props = {
  inputType: INPUT_TYPES;
  title: string;
  subtext: string;
  selectorOptions: typeof itemIssues;
  selectorType: string;
  selectorAction?: (value: string) => void;
  selectorSelectedOptions: string[];
  freeTextAction: (evt: React.ChangeEvent<HTMLTextAreaElement>) => void;
  freeText: string;
  back: () => void;
  next: () => void;

  currentPage: number;
  disableNext: boolean;
  ordering: number[];
};

function HelpPageInner(props: Props) {
  const renderBtns = () => {
    if (props.currentPage !== 5 && props.currentPage !== 7) {
      return (
        <div className="action-btn-group">
          {props.currentPage > 1 ? (
            <button
              className="back-btn hr-btn-hol margin-right-16"
              onClick={props.back}
              disabled={props.currentPage <= 1}
            >
              Back
            </button>
          ) : null}
          <button
            className="hr-btn-blue"
            onClick={props.next}
            disabled={props.disableNext}
            data-testid="next-button"
          >
            Next
          </button>
        </div>
      );
    } else {
      return (
        <div className="action-btn-group">
          <a href="/myhungryroot/">
            <button className="back-btn hr-btn-blue margin-right-16">
              Done
            </button>
          </a>
        </div>
      );
    }
  };

  return (
    <div className="help-flow-page">
      <div className="hr-title-lg hr-mb-16">{props.title}</div>
      <div className="hr-mb-24">{props.subtext}</div>
      {props.inputType === INPUT_TYPES.SELECTOR ? (
        <Selector
          type={props.selectorType}
          action={props.selectorAction}
          options={props.selectorOptions}
          selected={props.selectorSelectedOptions}
          optionsOrder={props.ordering}
        />
      ) : props.inputType === INPUT_TYPES.TEXT_BOX ? (
        <textarea
          name="help-pg-text-feedback"
          placeholder="Tell us as much or as little as you’d like."
          className="text-feedback hr-mb-16"
          value={props.freeText}
          onChange={props.freeTextAction}
        />
      ) : null}
      {renderBtns()}
    </div>
  );
}

export default HelpPageInner;
